import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { WEBSOCKET_CONFIG } from '../constants/interegation-variebles';

export const useSocket = (
  companyId,
  metadataId = null,
  contactPhone = null,
  botConfigId = null,
  chatId = null,
) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!companyId) {
      if (socket) {
        socket.disconnect();
        setSocket(null);
      }
      setIsConnected(false);
      return;
    }

    const queryObj = {
      companyId,
      metadataId,
      phone: contactPhone,
      botConfigId,
      chatId,
    };

    const queryString = Object.entries(queryObj)
      .filter(([, value]) => value !== null && value !== undefined)
      .map(([key, value]) => `${key}:${value}`)
      .join('&');

    const newSocket = io(WEBSOCKET_CONFIG.SERVER_URL, {
      path: WEBSOCKET_CONFIG.PATH,
      query: { request: queryString },
      transports: WEBSOCKET_CONFIG.TRANSPORTS,
      forceNew: true,
      autoConnect: true,
      timeout: 20000,
    });

    setSocket(newSocket);

    newSocket.on('connect', () => {
      console.log('✅ Socket connected:', newSocket.id);
      setIsConnected(true);
    });

    newSocket.on('disconnect', () => {
      console.log('❌ Socket disconnected');
      setIsConnected(false);
    });

    return () => {
      console.log('Cleaning up socket...');
      newSocket.disconnect();
      setSocket(null);
    };
  }, [companyId, metadataId, contactPhone, botConfigId, chatId]);

  return { socket, isConnected };
};
